import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { isProductionRoute } from '@helpers/developmentMode';
import { useInDevMode } from '@hooks/useInDevMode';

export const DevelopmentModeRouteGuard: React.FC = (): JSX.Element | null => {
  const location = useLocation();
  const inDevMode = useInDevMode();

  if (inDevMode || isProductionRoute(location.pathname)) {
    return null;
  }

  return <Navigate to="/" replace />;
};
